// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__iN-vo","modalForm":"UpgradeEpcsModal_modalForm__1lS4A","modalFooter":"UpgradeEpcsModal_modalFooter__2Q9Dc"};